export default "__VITE_ASSET__qCMkuy$m__"